<template>
  <div>
    <div class="box__title">
      <h2 class="box__results-title">Rezultate</h2>
      <span class="box__count">{{orders.ordersCount}} ({{orders.productsCount}} produse)</span>
      <div class="box__pages">
        <paginate
          :page-count="orders.totalPages"
          :click-handler="changePage"
          v-model="page"
          :prev-class="'box__pagination-link'"
          :prev-text="'<a><i class=\'icon-arrow_left\'></i></a>'"
          :next-class="'box__pagination-link'"
          :next-text="'<a><i class=\'icon-arrow_right\'></i></a>'"
          :container-class="'box__pagination'"
          :page-class="'box__pagination-link'">
        </paginate>
      </div>
    </div>
    <div class="box box__comenzi">
      <div class="box__wrap box__comenzi">
        <div class="box__comenzi-wrap">
          <div class="box__comenzi-container">
            <div class="box__comenzi-transport">
              <div class="box__comenzi-transport-wrap">
                <label for="transport" class="product__label">Transport</label>
                <select name="transport"
                        id="transport"
                        :class="courierId != '' ? 'product__input border-info' : 'product__input'"
                        v-model="courierId">
                  <option v-for="item in couriers" :key="'courier_' + item.id" :value="item.id">{{item.name}}</option>
                </select>
              </div>
              <label>
                <input type="checkbox" v-model="isSimpleOrders" />
                Comenzi simple
              </label>
              <button @click="generateAWBs" :disabled="isGeneratingAwb" class="btn btn--light btn--outline" style="margin-left: 10px;">
                {{ isGeneratingAwb ? 'Se generează…' : 'Generează AWB' }}
              </button>
              <a v-if="isAltex" @click="downloadAWBsAltex" class="btn btn--light btn--outline" style="margin-left: 10px;">Descarca AWB Altex</a>
              <button v-if="isSameday" @click="downloadAWBsSameday" :disabled="isDownloadingSameday" class="btn btn--light btn--outline" style="margin-left: 10px;">
                {{ isDownloadingSameday ? 'Se descarcă…' : 'Descarcă AWB Sameday' }}
              </button>
              <a @click="deleteAWBs" class="btn btn--light btn--delete">
                <i class="far fa-trash-alt btn--delete-trash"></i>
                <span>Șterge AWB</span>
              </a>
            </div>
          </div>
          <div class="box__comenzi-container">
            <div class="box__comenzi-transport">
              <div class="box__comenzi-transport-wrap">
                <label for="transport" class="product__label">
                  Modifică starea
                </label>
                <select name="transport"
                        id="transport"
                        :class="newstatus != 0 ? 'product__input border-info' : 'product__input'"
                        v-model="newstatus">
                  <option v-for="item in orderStatusesForChange" :key="'status_' + item.id" :value="item.id">{{item.name}}</option>
                </select>
              </div>
              <a @click="changeOrderStatuses" :disabled="isChangingStatusPending" :class="isChangingStatusPending ? 'btn btn--light btn--outline disabled' : 'btn btn--light btn--outline'">
                Modifica starea
              </a>
            </div>
          </div>
          <div class="box__comenzi-container">
          
            <!--  <div class="box__comenzi-transport">
              <div class="box__comenzi-transport-wrap">
                <label for="invoice-series" class="product__label">Facturare</label>
                <select name="invoice-series"
                  id="invoice-series"
                  :class="invoiceGeneratorSettings.series != 'BP' ? 'product__input border-info' : 'product__input'"
                  v-model="invoiceGeneratorSettings.series">
                  <option value="BP">BESTSELLER PUBLISHING SRL</option>
                  <option value="BKZ">BOOKZONE SRL</option>
                </select>
              </div>
              <div class="box__comenzi-transport-wrap">
                <label for="transport" class="product__label">Data facturarii</label>
                <input
                    class="product__input"
                    type="date"
                    id="data-min"
                    placeholder="min"
                    v-model="invoiceGeneratorSettings.date"
                    disabled="disabled"
                  />
              </div>
              <div class="box__comenzi-transport-wrap">
                <label for="transport" class="product__label">Borderou (opțional)</label>
                <input
                    class="product__input"
                    type="text"
                    v-model="invoiceGeneratorSettings.borderouNumber"
                  />
              </div>
              <a @click="generateInvoices" class="btn btn--light btn--outline">
                Generează facturi
              </a>
            </div> -->
          </div>
          <!-- --/--  .box__comenzi-container  -->
          <!--<div class="box__comenzi-container">
            <div class="box__comenzi-transport">
              <a @click="sendPaymentLinkBySMS" class="btn btn--light btn--outline">Trimite SMS cu link de plată</a>
            </div>
          </div>-->
          <!-- --/--  .box__comenzi-container  -->
        </div>
        <div v-if="selectedIds.length > 0 && stockCallSuccess == true">
          <div class="orders-alert" v-if="insufficientStock.length > 0">
            <p>ATENTIE!!! Exista carti cu stoc insuficient pentru comenzile in prelucrare selectate:</p>
            <ul>
              <li v-for="item in insufficientStock" :key="'insStock_' + item.productId">{{ item.productName }}: <b>{{ item.quantityNeeded }}</b> buc. necesare / <b>{{ item.availableStock }}</b> buc. in stoc</li>
            </ul>
          </div>
          <div class="orders-alert green" v-else>
            <p>Comenzile in prelucrare selectate au stoc suficient. :)</p>
          </div>
        </div>
         <div class="orders-alert" v-if="awbErrorMessage.length > 0">
            <p v-html="awbErrorMessage"></p>
          </div>
          <!-- --/--  .box__comenzi-wrap  -->
          <div class="box__comenzi-wrap box_overflow">
            <table>
              <thead>
                <tr>
                  <td>#</td>
                  <td style="width: 3rem">
                    <input
                      type="checkbox"
                      name="select-opt"
                      id="select-opt"
                      @click="toggleAll"
                      v-model="selectedAll"
                      style="width:16px !important; height:16px !important;"
                    />
                  </td>
                  <td>ID_Comandă</td>
                  <td>Factură</td>
                  <td style="width: 9rem;">Date client</td>
                  <td>Valoare comandă</td>
                  <td style="width: 9rem;">Data</td>
                  <td style="width: 9rem;">Metodă livrare</td>
                  <td style="width: 10rem;">Adresă livrare</td>
                  <td style="width: 9rem;">Observații</td>
                  <td style="width: 18rem;">Conținut</td>
                  <td>Metodă plată</td>
                  <td style="width: 9rem;">AWB</td>
                  <td>Opțiuni</td>
                  <td>Stare</td>
                  <td>Semnale</td>
                  <td>Note</td>
                </tr>
              </thead>
              <tbody>
                <tr
                    v-for="item in orders.items"
                    :key="'order_' + item.id"
                    :class="getRowClass(item)">
                  <td>
                    <a :href="'/order/' + item.id">{{item.nrCrt}}</a>
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      name="select-opt"
                      id="select-opt"
                      :value="item.id"
                      v-model="selectedIds"
                      @change="onOrderSelect"
                      style="width:16px !important; height:16px !important;"
                      v-if="item.out !== true"
                    />
                  </td>
                  <td>
                    <a :href="'/order/' + item.id">{{item.id}} <br /> {{item.idEncrypt}}</a>
                    
                    <template v-if="item.idEncryptRelated">
                      <br />
                      <a :href="'/order-crypt/' + item.idEncryptRelated" class="btn--green" style="font-size: 11px; margin: 5px 10px; display: block;">
                        Legătura cu {{item.idEncryptRelated}}
                      </a>
                    </template>
                  </td>
                  <td>{{item.invoiceNumber}}</td>
                  <td>
                    <p>{{item.memberName}}</p>
                    {{item.memberPhone}}
                  </td>
                  <td>{{item.totalPrice}} Lei</td>
                  <td>{{item.dateAdded}}</td>
                  <td>{{item.shipping == 1 ? 'Livrare prin curier' : item.shipping == 3 ? 'Livrare prin DHL' : item.shipping == 6 ? 'Livrare prin Easybox' : 'Ridicare de la sediu'}}</td>
                  <td>{{item.deliveryLocation}}</td>
                  <td>{{item.observations}}</td>
                  <td>
                    <span v-html="item.productsString"></span>
                  </td>
                  <td>
                    <i class="fas fa-truck"></i>
                    <img v-if="item.paymentMethod == '2'" src="../../assets/images/card.png" style="width:50px; margin: 0 auto;" title="Card online" />
                    <img v-if="item.paymentMethod == '1'" src="../../assets/images/ramburs.png" style="width:50px; margin: 0 auto;" title="Ramburs la livrare" />
                    <img v-if="item.paymentMethod == '3'" src="../../assets/images/transfer.png" style="width:50px; margin: 0 auto;" title="Transfer bancar" />

                  </td>
                  <td>
                    <i class="fas fa-truck"></i>
                    <b>{{item.courierId != 0 && item.awb != null ? getCourier(item.courierId) : ''}}</b><br>
                    {{item.awb}}
                  </td>
                  <td>
                    <a @click="onCopyOrder(item.id)" class="btn btn--light btn--outline" v-if="item.out !== true">Duplicare</a>
                    <a target="_blank" v-if="item.courierId == 12 && item.awb != null && item.awb != ''" :href="baseEmagAPIUrl + 'emag/callbacks/order/print-awb/' + item.id" class="btn btn--light btn--outline">Printeaza AWB</a>
                    <a target="_blank" v-if="item.courierId == 13 && item.awb != null && item.awb != ''" :href="baseAltexAPIUrl + 'order/print-awb/' + item.id" class="btn btn--light btn--outline">Printeaza AWB</a>
                  </td>
                  <td>{{getStatus(item.status)}}</td>
                  <td>
                    <div v-if="item.returnedOrders > 0 && (((item.paymentMethod ==2 || item.paymentMethod == 3) && item.status==1) || item.paymentMethod == 1)">
                      <div v-if="item.returnedOrders > 0" class="mt-2" style="font-size: 12px;">{{(item.returnedOrders * 100 / item.totalOrders).toFixed(2) }} %</div>
                      <b-progress v-if="item.returnedOrders > 0" :max="item.totalOrders" class="mt-2" height="15px" style="color:black" :label="`${(item.returnedOrders * 100 / item.totalOrders).toFixed(2)} %`">
                        <b-progress-bar class="bg-red" :value="item.returnedOrders" ></b-progress-bar>
                      </b-progress>
                      <div v-if="item.returnedOrders > 0" class="mt-2" style="font-size: 12px;">{{item.returnedOrders}} din {{item.totalOrders}} comenzi returnate</div>
                    </div>
                    
                    {{ item.signals }}
                    {{ item.totalPrice >= 1000 ? 'Comanda depășește 1000 de lei. Trebuie confirmată telefonic.' : '' }}
                  </td>
                  <td>{{item.notes}}</td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
      <div class="box__title">
        <h2 class="box__results-title">Rezultate</h2>
        <span class="box__count">{{orders.productsCount}}</span>
        <div class="box__pages">
          <paginate
            :page-count="orders.totalPages"
            :click-handler="changePage"
            v-model="page"
            :prev-class="'box__pagination-link'"
            :prev-text="'<a><i class=\'icon-arrow_left\'></i></a>'"
            :next-class="'box__pagination-link'"
            :next-text="'<a><i class=\'icon-arrow_right\'></i></a>'"
            :container-class="'box__pagination'"
            :page-class="'box__pagination-link'">
          </paginate>
        </div>
      </div>
    </div>
    <b-modal size="xl" id="modal-1" title="Atentionare stoc" hide-footer>
      <p>ATENTIE!!! Exista carti cu stoc insuficient pentru comenzile in prelucrare selectate:</p>
      <ul>
        <li v-for="item in insufficientStock" :key="'insStock_' + item.productId">{{ item.productName }}: <b>{{ item.quantityNeeded }}</b> buc. necesare / <b>{{ item.availableStock }}</b> buc. in stoc</li>
      </ul>
      <b-button class="mt-3" block @click="$bvModal.hide('modal-1')">Ok</b-button>
    </b-modal>
    <b-modal size="lg" id="modal-2" title="Duplicare comanda" hide-footer>
    <input type="checkbox" id="createNewBillingData" v-model="createNewBillingData">
    <label for="createNewBillingData" class="product__label">Vrei sa creezi date de facturare si de livrare noi?</label>
        <div class="box__footer">
          <b-button class="mt-3" block @click="copyOrder()">Duplicare</b-button>
          <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Inchide</b-button>
        </div>
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios';
import Paginate from 'vuejs-paginate'
import moment from 'moment'

export default {
  props: ["orders", "isAltex", "isSameday"],
  components: {
  	Paginate
  },
  data () {
    return {
      isSimpleOrders: false,
      selectedAll: false,
      orderStatusesForChange: [],
      orderStatuses:[],
      couriers:[],
      courierId:'',
      statusId:'',
      selectedIds : [],
      insufficientStock: [],
      newstatus: 0,
      stockCallSuccess: false,
      invoiceGeneratorSettings: {
        date: null,
        series: 'BP',
        borderouNumber: null
      },
      isChangingStatusPending: false,
      page: 1,
      createNewBillingData: false, 
      selectedForDuplicationOrderId: null,
      isGeneratingAwb: false,
      isDownloadingSameday: false,
      awbErrorMessage: '',
  	}
  },
  mounted() {
    var startdate = moment();
    this.invoiceGeneratorSettings.date = startdate.format("YYYY-MM-DD");
    this.getOrderStatuses();
    this.getCouriers();
  },
  methods: {
    getRowClass(item) {
      const signals = item.signalsType;

      if (
        (
          signals.includes(2) &&
          (
            (
              (item.paymentMethod === 2 || item.paymentMethod === 3) &&
              item.status == 1
            ) ||
            item.paymentMethod === 1
          )
        ) || 
        signals.includes(7) || 
        item.totalPrice >= 1000 
      )
      {
        return 'product__title row-red';
      }

      if (signals.includes(1) || signals.includes(6) ) {
        return 'product__title row-yellow';
      }

      if (signals.includes(3) ) {
        return 'product__title row-green';
      }

      if (signals.includes(4) ) {
        return 'product__title row-pink';
      }

      return 'product__title';
    },
    changePage(item){
      this.$emit('changePage', item)
      this.page = item
    },
    cleanSelectedIds(){
      this.selectedIds = [];     
    },
    getOrderStatuses(){
    let self = this;      
        axios.get(this.baseAdminUrl + 'ordertatuses')
          .then(function (response) {
            self.orderStatuses = response.data;
            self.orderStatusesForChange = response.data.filter((e) => {
              return (e.id == 4 || e.id == 23);
            });
        });
    },
    getCouriers(){
      let self = this;      
          axios.get(this.baseAdminUrl + 'couriers')
            .then(function (response) {
              self.couriers = response.data;
          });
    },
    generateInvoices(){
      axios.post(this.baseAdminUrl + "order/generate-bulk-invoices", {...this.invoiceGeneratorSettings, orderIds: this.selectedIds})
          .then(response => {
             this.$emit('refreshPage')
          }).catch(console.error)
    },
    sendPaymentLinkBySMS() {
      let self = this;
      axios.post(this.baseAdminUrl + "order/sendBulkSMS/", this.selectedIds)
        .then(response => {
          this.$emit('refreshPage')
        }).catch(console.error)
    },
    checkIfAllSelectedOrdersHaveSelectedCourierId(selectedIds, orders) {
      for (let i = 0; i < selectedIds.length; i++) {
        const orderId = selectedIds[i];
        const order = orders.find(o => o.id === orderId);
        if (!order || order.courierId !== this.courierId) {
          return false;
        }
      }
      return true;
    },
    generateAWBs(){
      if (this.isGeneratingAwb) {
        return;
      }

      if (!confirm('Ești sigur?')) {
        this.isGeneratingAwb = false;
        return;
      }

      if (this.selectedIds.length === 0) {
        alert('Selectează cel puțin o comandă.');
        this.isGeneratingAwb = false;
        return;
      }

      if (this.checkIfAllSelectedOrdersHaveSelectedCourierId(this.selectedIds, this.orders.items) === false) {
        if (!confirm('Unele comenzi selectate nu au curierul ales. Dorești să continui?')) {
          this.isGeneratingAwb = false;
          return;
        }
      }

      this.isGeneratingAwb = true;
      this.awbErrorMessage = ''

      let awbGeneratorSettings = {
        courierId: this.courierId,
        isSimpleOrders: this.isSimpleOrders,
        orderIds: this.selectedIds
      };
      if (this.courierId == 7){
        axios.post(this.baseAdminUrl + "order/generateawbFAN/", awbGeneratorSettings)
          .then(response => {
            this.downloadAWBsFan();
          }).catch(err => {
            alert(err.response.data);
            this.downloadAWBsFan();
            this.isGeneratingAwb = false;
          })
          .finally(() => {
            this.isGeneratingAwb = false;
          });
      }
      else if (this.courierId == 14){
        // TrendyolFan - noul API REST FAN Courier (FanCourierController), inlocuieste vechea integrare SelfAWB pentru acest curier.
        axios.post(this.baseAdminUrl + "fancourier/generate-awb", { orderIds: this.selectedIds })
          .then(response => {
            this.downloadAWBsFanCourier();
          }).catch(err => {
            alert(err.response.data);
            this.downloadAWBsFanCourier();
            this.isGeneratingAwb = false;
          })
          .finally(() => {
            this.isGeneratingAwb = false;
          });
      }
      else{
        axios.post(this.baseAdminUrl + "order/GenerateAwb/", awbGeneratorSettings)
          .then(response => {
            const errorMessage = response.data;

            // Download pentru DHL (courier ID 3)
            if(this.courierId === 3){
              axios.post(this.baseAdminUrl + "order/downlaodAWBDhl?ts=" + new Date().getTime(), awbGeneratorSettings, {responseType: 'blob'})
                  .then(response => {
                    const url = URL.createObjectURL(response.data)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = 'DhlAWBDownloadFile.pdf'
                    document.body.appendChild(a)
                    a.click()
                    URL.revokeObjectURL(url)
                    a.remove()
                  })
            }

            // Download pentru SameDay (courier ID 6)
            if(this.courierId === 6){
              return this.downloadAWBsSameday();
            }

            if (errorMessage && errorMessage.length > 0) {
              this.awbErrorMessage = errorMessage;
            }

            this.$emit('refreshPage')
          }).catch(err => {
            let errText = err.response.data;
            alert(errText);
            this.isGeneratingAwb = false;
          })
          .finally(() => {
            this.isGeneratingAwb = false;
          });
      }
    },
    downloadAWBsFan(){
        let self = this;
        axios.post(this.baseAdminUrl + "order/downloadawbFAN/"+ this.courierId, this.selectedIds, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = 'awbs'
                link.click()
                URL.revokeObjectURL(link.href)
                this.$emit('refreshPage')
            }).catch(console.error)
    },
    downloadAWBsFanCourier(){
        // TrendyolFan (14) - descarca etichetele PDF generate prin noul API FanCourierController
        axios.post(this.baseAdminUrl + "fancourier/print-awb", this.selectedIds, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = 'awbs'
                link.click()
                URL.revokeObjectURL(link.href)
                this.$emit('refreshPage')
            }).catch(console.error)
    },
    downloadAWBsSameday(){
        if (this.selectedIds.length === 0) {
          alert('Selectează cel puțin o comandă.');
          return;
        }
        axios.post(this.baseAdminUrl + 'order/downloadawbSameday', this.selectedIds, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = 'awbs-sameday.pdf'
                link.click()
                URL.revokeObjectURL(link.href)
                this.$emit('refreshPage')
            }).catch(err => {
                console.error(err)
                alert('Eroare la descărcarea AWB Sameday.')
            })
    },
    downloadAWBsAltex(){
        let self = this;
        axios.post(this.baseAltexAPIUrl + "order/print-awbs", this.selectedIds, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = 'awbs'
                link.click()
                URL.revokeObjectURL(link.href)
                this.$emit('refreshPage')
            }).catch(console.error)
    },
    deleteAWBs(){
      if (confirm('Esti sigur?')) {
        let self = this;
        axios.post(this.baseAdminUrl + "order/deleteawb/", this.selectedIds)
            .then(response => {
               this.$emit('refreshPage')
            }).catch(console.error)
      }
    },
    changeOrderStatuses(){

      if (confirm('ATENTIE!!! Unele modificari in starea comenzii pot genera automat facturi. Esti sigur?')) {
        this.isChangingStatusPending = false;
        let self = this;
        axios.post(this.baseAdminUrl + "order/changestatus/"+ this.newstatus, this.selectedIds)
            .then(response => {
               this.$emit('refreshPage')
               this.isChangingStatusPending = false
            }).catch(console.error)
      }
    },
    getCourier(item){
      
      let couriers = this.couriers.filter(e => {
          return e.id == item
      })  
      return couriers.length > 0 ? couriers[0].name : '';
    },
    getStatus(item){
      
      let statuses = this.orderStatuses.filter(e => {
          return e.id == item
      })  
      return statuses.length > 0 ? statuses[0].name : '';
    },
    toggleAll(){
      if (this.selectedAll){
        this.selectedIds = [];
      }
      else{
        this.selectedIds = this.orders.items.map(el => el.id)
        this.onOrderSelect();
      }
    },
    copyOrder(){
      let self = this;
      this.hideModal();
      axios.post(this.baseAdminUrl + "order/duplicate/"+ this.selectedForDuplicationOrderId + "/" + this.createNewBillingData)
          .then(response => {
             window.location.href = '/order/' + response.data
             self.createNewBillingData = false
          }).catch(console.error)
    },
    onCopyOrder(orderId){
      this.selectedForDuplicationOrderId = orderId;
      this.$bvModal.show('modal-2');
    },
    hideModal(){
      this.$bvModal.hide('modal-2');
    },
    onOrderSelect() {
      clearTimeout(this._timerId);
        this.stockCallSuccess = false;
        this.isLoading = true;
        this._timerId = setTimeout(() => {
          let self = this;

          axios.post(this.baseAdminUrl + "order/check-orders-stock", this.selectedIds)
            .then(function (response) {
              self.insufficientStock = response.data;
              self.stockCallSuccess = true;
              if (self.insufficientStock.length > 0){
                self.$bvModal.show("modal-1");
              }
            });
        }, 1000);
    },
  } 
};
</script>
<style scoped>
  .bg-red{
      background-color: red !important;
    }
  input[type="checkbox"]{
    width: unset !important;
  }
  .box {
    padding: 2rem;
  }
  .box__comenzi-wrap {
    width: 100%;
    max-width: 172rem;
  }

  .box__comenzi {
    width: 100%;
    max-width: 175rem;
  }
  .green{
    color: green;
    font-weight: bold;
  }

  .row-yellow td {
    background-color: #fffae5;
  }

  .row-red td {
    background-color: #ffe5e5; 
  }

  .row-green td {
    background-color: #99EDC3;
  }

  .row-pink td {
    background-color: #f7d1ff;
  }

  .orders-alert {
    background-color: red;
    padding: 4px;
    color: white;
    font-size: 12px;
    border-radius: 4px;
    margin-bottom: 16px;
  }

  
  .orders-alert.green {
    background-color: green;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.5;

  }
  .box_overflow {
    overflow-x:auto;
  }
  @media screen and (max-width: 900px) {
    .box__title {
      flex-direction: column;
    }
    .box__comenzi-wrap {
      flex-direction: column;
      align-items: flex-start;
    }
    .box__comenzi-container:not(:last-child) {
      border: none;
    }
    .box__pages ul.box__pagination {
      max-width: 300px;
    }
  }
</style>


